import { DEFAULT_FEATURES, resolveFeatures, sameFeatures } from '../core/rules/features'
import type { SiteFeatures } from '../core/types/site'

/**
 * De onderdelen die nu aan staan, voor de hele site (shop én beheer). Wordt gezet door
 * `applySiteSettings` (GET /site) en door het beheer na laden en opslaan. Lezen in React gaat via
 * `useFeatures()`, buiten React (StoreContext-acties) via `currentFeatures()`.
 *
 * Bewust een eigen klein store, los van `localSite()`: die levert de vaste standaard, zodat het
 * opgeslagen demo-concept (dat op `localSite()` is gebaseerd) niet ongeldig wordt.
 */
let current: SiteFeatures = { ...DEFAULT_FEATURES }
const listeners = new Set<() => void>()

export const currentFeatures = (): SiteFeatures => current

export function applyFeatures(raw: unknown) {
  const next = resolveFeatures(raw)
  if (sameFeatures(next, current)) return
  current = next
  listeners.forEach((l) => l())
}

export function subscribeFeatures(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
